export default __webpack_public_path__ + "static/media/stat-data-yellow.a5c67239.svg";